module.exports = __webpack_public_path__ + "static/media/ios_badge_en.39f113e9.svg";